const DEFAULT_PAUSE_IN_TIMESLOTS = {
  amount: 30,
  unit: 'minutes'
}

export default DEFAULT_PAUSE_IN_TIMESLOTS
